import React from 'react';
import { 
  Mail 
} from '@mui/icons-material';
import { Button } from '@mui/material';

import FabButton from "@components/input/buttons/FabButton";

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function MailButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        <Mail />
      </FabButton>
    );
  } else {
    return (
      <Button 
        disabled={disabled} 
        onClick={onClick} 
        variant="contained" color="primary">
        <Mail />&nbsp;{ label }
      </Button>
    );
  }
}
